<template>
  <div class="feeds-card" :class="{ 'feeds-card--hoverable': hoverable }">
    <div v-if="title || $slots['header-actions']" class="feeds-card-header">
      <h3 class="feeds-card-title">{{ title }}</h3>
      <div class="feeds-card-header-actions">
        <slot name="header-actions" />
      </div>
    </div>
    <div class="feeds-card-body" :class="{ compact: compact }">
      <slot />
    </div>
    <div v-if="$slots.footer" class="feeds-card-footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeedsCard',
  props: {
    title: {
      type: String,
      default: ''
    },
    compact: {
      type: Boolean,
      default: false
    },
    hoverable: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
.feeds-card {
  background: var(--bg-secondary);
  border-radius: var(--radius-lg);
  /* border: 1px solid var(--border-light); */
  box-shadow: var(--shadow-sm);
  /* overflow:visible allows dropdowns/tooltips to escape the card */
}

.feeds-card--hoverable {
  transition: box-shadow 0.2s ease;
}

.feeds-card--hoverable:hover {
  box-shadow: var(--shadow-md);
}

.feeds-card-header {
  padding: 18px 24px;
  border-bottom: 1px solid var(--border-light);
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--bg-tertiary);
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
}

.feeds-card-title {
  font-family: 'Nunito', sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.feeds-card-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.feeds-card-body {
  padding: 24px;
}

.feeds-card-body.compact {
  padding: 16px 24px;
}

.feeds-card-footer {
  padding: 16px 24px;
  border-top: 1px solid var(--border-light);
  background: var(--bg-tertiary);
}

.feeds-card + .feeds-card {
  margin-top: 24px;
}

@media (max-width: 768px) {
  .feeds-card {
    border-radius: var(--radius-md);
  }

  .feeds-card-header {
    padding: 14px 16px;
    border-radius: var(--radius-md) var(--radius-md) 0 0;
  }

  .feeds-card-body {
    padding: 16px;
  }

  .feeds-card-body.compact {
    padding: 12px 16px;
  }

  .feeds-card + .feeds-card {
    margin-top: 16px;
  }
}
</style>
